import { useAppSelector } from "../../../app";

const useAccountPopover = () => {
  const user = useAppSelector((state) => state.userReducer.user);

  return {
    user,
    avatarUrl: user?.avatar || null,
    fallback: user?.defaultAvatar || "",
  };
};

export default useAccountPopover;
